module.exports = __webpack_public_path__ + "static/media/central-african-republic.dd7eb581.svg";